import type { FC } from 'react'
import Image from 'next/image'
import type { GetUsers_getUsers } from '@g4g/graphql/src/shop/__generated__/GetUsers'
import { classNames } from '@g4g/utils/src/react/class-names'
import vip1container from '@/shop/public/shared-assets/img/resources/vip_container_1_sm.png'
import vip2container from '@/shop/public/shared-assets/img/resources/vip_container_2_sm.png'
import vip3container from '@/shop/public/shared-assets/img/resources/vip_container_3_sm.png'
import vip4container from '@/shop/public/shared-assets/img/resources/vip_container_4_sm.png'
import vip5container from '@/shop/public/shared-assets/img/resources/vip_container_5_sm.png'
import { getVipCategory } from '@g4g/utils/src/gameDataUtils'
import { __DEV__ } from '@g4g/utils/src/react/environment'

const vipAvatarContainers = [
  vip1container,
  vip2container,
  vip3container,
  vip4container,
  vip5container,
]
const SMALL_AVATAR_SIZE = 20
const NORMAL_AVATAR_SIZE = 32
const ADDED_CONTAINER_SIZE = 8

const RecipientAvatar: FC<{ recipient: GetUsers_getUsers; small?: boolean }> = ({
  recipient,
  small,
}) => {
  const avatarImgSize = small ? SMALL_AVATAR_SIZE : NORMAL_AVATAR_SIZE

  return (
    <div
      className={classNames(
        'relative justify-center rounded-full flex items-center',
        small ? 'w-7 h-7' : 'w-10 h-10'
      )}
    >
      <Image
        src={vipAvatarContainers[getVipCategory({ exp: recipient.userState.vipXP }) - 1]}
        width={avatarImgSize + ADDED_CONTAINER_SIZE}
        height={avatarImgSize + ADDED_CONTAINER_SIZE}
        alt=""
      />
      <div className="absolute flex items-center justify-center w-full h-full">
        {/* On local, staging faces break because they're not in "allowed domains" list. */}
        {!__DEV__ && (
          <Image
            width={avatarImgSize}
            height={avatarImgSize}
            className="overflow-hidden"
            src={recipient.faceUrl}
            alt={`${recipient.primaryLogin?.displayName} face avatar`}
          />
        )}
      </div>
    </div>
  )
}

export default RecipientAvatar
